import React, { useState, useEffect } from 'react'
import { Alert, Button, Group, Modal, Stack, TextInput } from '@mantine/core'
import { toast } from '../services/utils/toast'

const StationOptionModal = ({
	show,
	onClose,
	onAdd,
	experienceSlug,
	station,
}) => {
	const [name, setName] = useState('')
	const [address, setAddress] = useState('')
	const [uploading, setUploading] = useState(false)
	const [error, setError] = useState('')

	useEffect(() => {
		if (station) {
			setName(station.name || '')
			setAddress(station.address || '')
		} else {
			setName('')
			setAddress('')
		}
		setError('')
		setUploading(false)
	}, [station, show])

	const handleSubmit = async () => {
		const trimmedName = name.trim()

		if (!trimmedName) {
			setError('Add a station option name before saving.')
			return
		}

		setError('')
		setUploading(true)
		try {
			await onAdd({ name: trimmedName, address: address.trim() || null })
			toast.success({
				title: station ? 'Station option updated' : 'Station option added',
				message: `${trimmedName} was saved successfully.`,
			})
		} catch (err) {
			console.error('Error saving station option', err)
			setError(err.message || 'Failed to save station option.')
		} finally {
			setUploading(false)
		}
	}

	return (
		<Modal
			opened={show}
			onClose={onClose}
			title={`${station ? 'Edit' : 'Add'} Station Option`}
			centered
		>
			<Stack spacing='md'>
				{error && (
					<Alert color='red' title='Station option not saved'>
						{error}
					</Alert>
				)}

				<TextInput
					label='Name'
					value={name}
					error={error && !name.trim() ? 'Name is required.' : null}
					onChange={(e) => {
						setName(e.target.value)
						if (error) setError('')
					}}
				/>

				<TextInput
					label='Address'
					description='Shown to travelers with map and directions links.'
					placeholder='3799 S Las Vegas Blvd, Las Vegas, NV 89109'
					value={address}
					onChange={(e) => setAddress(e.target.value)}
				/>

				<Group position='right' spacing='sm'>
					<Button variant='default' onClick={onClose}>
						Cancel
					</Button>
					<Button onClick={handleSubmit} disabled={uploading}>
						{uploading ? 'Uploading...' : station ? 'Save Changes' : 'Add'}
					</Button>
				</Group>
			</Stack>
		</Modal>
	)
}

export default StationOptionModal
